<template>
    <div>
        <component :is="listComponent" :commentData="List" :paginationData="filterSet.page" v-if="listComponent"  />
        <component :is="paginationComponent" :paginationData="filterSet.page" :listLength="List.length" v-if="paginationComponent"  />
    </div>
</template>

<script>
    import EventBus from "@/utils/event-bus";
    import boardTemplateUtil from "@/components/board/boardTemplateUtil";
    import boardFilterUtil from "@/components/board/boardFilterUtil";
    import listMixins from "@/mixins/listMixins";
    import filterMixins from "@/mixins/filterMixins";
    import util from "@/mixins/util";
    import alertMixins from "@/mixins/alertMixins";
    import DeleteClass from "@/mixins/deleteClass";

    const {filterConfig} = boardFilterUtil;
    export default {
        name: "CommentListComponent",
        mixins: [filterMixins, listMixins, boardTemplateUtil, boardFilterUtil, alertMixins],
        components: {},
        inject: ['changeLoading'],
        provide: function () {
            return {
                setPage: this.setPage,
                boardCommentSetData: this.setData,
                boardCommentDelete: this.runDeleteConfirm,
            }
        },
        props: {
            boardType: {type: String, default: '',},
            boardKey: {default: 0},
          ssamsKey: {default: 0}
        },
        data() {
            return {
                commentListLayout: '',
                commentPaginationLayout: '',
                listComponent: null,
                paginationComponent: null,

                getFunc: '',
                listApiParamSet: {},
                paginationType: 'pagination',

                deleteFunc: '',
                deleteApiParamsSet: {},
                deleteSuccessType: 1,
                deleteFailTypes: {},

                keyName: '',

                pageRow: 10,
                DeleteClass: null,
                selectArr: [],
                deleteIndex: 0,
            }
        },
        created() {
            this.initConfig();
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
            this.loadLayout();
        },
        mounted() {
            EventBus.$on("getList",this.getList);
            this.getList(true);
        },
        beforeDestroy() {
            EventBus.$off("getList");
        },
        computed: {
            listLoader() {
                if (!this.commentListLayout) {
                    return null
                }
                return () => import(`@/template/board/comment/list/${this.commentListLayout}`)
            },
            paginationLoader() {
                if (!this.commentPaginationLayout) {
                    return null
                }
                return () => import(`@/template/board/comment/pagination/${this.commentPaginationLayout}`)
            },
        },
        methods: {
            boardCommentSetData({key,data}){
                this.setData(key,data)
            },
            setData(key, data) {
                this[key] = data;
                console.log('key',this[key])
            },
            initConfig() {
                let templateConfig = this.returnBoardTemplateConfig(this.boardType);
                this.commentListLayout = templateConfig.commentListLayout;
                this.commentPaginationLayout = templateConfig.commentPaginationLayout;

                let filterConfig = this.returnBoardFilterConfig(this.boardType);
                this.getFunc = filterConfig.getFunc;
                this.listApiParamSet = filterConfig.listApiParamSet;
                this.paginationType = filterConfig.paginationType;

                this.deleteFunc = filterConfig.deleteFunc;
                this.deleteApiParamsSet = filterConfig.deleteApiParamsSet;
                this.deleteSuccessType = filterConfig.deleteSuccessType;
                this.deleteFailTypes = filterConfig.deleteFailTypes;

                this.keyName = filterConfig.keyName;

                this.listApiParamSet.pa = this.boardKey;
                let listOptions = {
                    url: this.$api.$board[this.getFunc],
                    defaultParams: this.listApiParamSet,
                };
                this.initList('api', listOptions);

                this.newDeleteClass();
            },
            newDeleteClass() {
                if(this.deleteApiParamsSet.hasOwnProperty('wr_parent')) {
                    this.deleteApiParamsSet.wr_parent = this.boardKey;
                }
                let deleteOptions = {
                    func: this.$api.$board[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            },
            runDeleteConfirm() {
                if (this.selectArr.length === 0) {
                    this.errorAlert('목록을 선택해주세요.');
                    return false;
                }
                this.createConfirm({
                    content: '정말 삭제하시겠습니까?',
                    confirm: () => {
                        this.deleteIndex = 0;
                        this.deleteLastIndex = this.selectArr.length - 1;
                        this.runDelete();
                    }
                })
            },
            runDelete() {
                this.changeLoading(true);
                this.DeleteClass.runDelete(this.selectArr[this.deleteIndex]);
            },
            deleteAfterFunc() {
                this.getLastComment(this.selectArr[this.deleteIndex]);
                if (this.deleteIndex < this.deleteLastIndex) {
                    this.deleteIndex = this.deleteIndex + 1;
                    this.runDelete()
                } else {
                    this.changeLoading(false);
                    this.createAlert({
                        content: '삭제되었습니다.',
                        hide: () => {
                            this.selectArr = [];
                        }
                    })
                }
            },
            getLastComment(key) {
                let commentIndex = this.List.findIndex(comment => comment[this.keyName] === key);
                if(commentIndex < 0) {
                    return false;
                }
                this.List.splice(commentIndex, 1);
                this.filterSet.page.total = this.filterSet.page.total - 1;
                if(this.List.length < this.filterSet.page.total - 1) {
                    let params = JSON.parse(JSON.stringify(this.listApiParamSet));
                    params.page = this.filterSet.page.page * this.pageRow + 1;
                    params.sp = 1;
                    this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
                        if(res.List.length > 0) {
                            this.List.push(res.List[0]);
                        }
                    })
                }
            },
            loadLayout() {
                this.listLoader()
                    .then(() => {
                        this.listComponent = () => this.listLoader()
                    })
                    .catch(() => {
                        this.listComponent = () => import('@/template/board/comment/list/CommentListDefaultLayout')
                    })
                if(this.paginationLoader != null) {
                    this.paginationLoader()
                        .then(() => {
                            this.paginationComponent = () => this.paginationLoader()
                        })
                        .catch(() => {
                            this.paginationComponent = () => import('@/template/board/comment/pagination/CommentPaginationDefaultLayout')
                        })
                }
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
